import DomUtilWrapper from "../wrappers/Dom";


interface IDomWrapper extends VideoJSDomUtil{
    new():IDomWrapper
}
let IDomWrapper = <IDomWrapper><any>function(){};
IDomWrapper.prototype = DomUtilWrapper;

class Dom extends IDomWrapper{

    removeEl(element:HTMLElement){
        element.parentElement.removeChild(element);
    }

    // Migrate this from video.js 6.x
    // https://github.com/videojs/video.js/blob/v6.4.0/src/js/utils/dom.js#L94
    isInFrame() {
        // We need a try/catch here because Safari will throw errors when attempting
        // to get either `parent` or `self`
        try {
            return window.parent !== window.self;
        } catch (x) {
            return true;
        }
    }

}

export default new Dom();


// WEBPACK FOOTER //
// ./src/app/utils/custom/Dom.ts